/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class DebugService {
  /**
   * 📱 Generate a pre-signed S3 URL for debug file uploads
   * @param requestBody
   * @returns any Pre-signed upload URL generated successfully
   * @throws ApiError
   */
  public static generateDebugUploadUrl(requestBody: {
    /**
     * Original filename for the debug file
     */
    filename: string
    /**
     * MIME type of the file to upload
     */
    content_type: 'application/json' | 'application/x-sqlite3'
  }): CancelablePromise<{
    data: {
      /**
       * Pre-signed S3 upload URL
       */
      upload_url: string
      /**
       * Content type for the upload
       */
      content_type: string
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/debug/generateUploadUrl',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
        429: `Too many requests`,
      },
    })
  }
}
